import React, { useRef, useEffect } from "react"
import lodash from "lodash"

import { useRouter } from "components/Router"
import { useCustomer } from "components/Customer"

const CustomerChangeNavigator = props => {
  const { history } = useRouter()

  const { currentCustomer } = useCustomer()

  const isMount = useRef(true)

  useEffect(() => {
    if (isMount.current) {
      isMount.current = false
      return
    }
    history.push("/")
  }, [currentCustomer])

  return null
}

export default CustomerChangeNavigator
